import { z } from "zod";

import i18n from "@/i18n";
import { InputField } from "@/features/FormCard/Fields";

import { parseIntValue } from "@/features/FormCard/utils";

import { EditForm } from "@/features/Edit/types.ts";

export const a7FIAIssuersEditForm: EditForm = {
  table_name: "a7_fia_issuers",
  browse_url: "/admin/fia/tree_view?starting_node=issuer",
  formSchema: z.object({
    denomination_du_sous_jacent: z.string().nullable(),
    lei: z.string().nullable().optional(),
    identifiant_fiscal_du_sous_jacent: z.string().nullable().optional(),
    societe_mere_id: z.preprocess(
      (val) => parseIntValue(val as string),
      z.number().int().nullable(),
    ),
  }),
  adjustData: (data) => {
    if (data.lei == "") return { ...data, lei: null };
    return data;
  },
  formBodyContent: (form, multiFieldOptions) => (
    <div className="grid gap-2">
      <div className="grid grid-cols-4 gap-2">
        <InputField
          name="denomination_du_sous_jacent"
          label={i18n.t("a7_fia_issuers.columns.denomination_du_sous_jacent", {
            ns: "tables",
            defaultValue: "Name",
          })}
          className="col-span-2"
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="lei"
          label={i18n.t("a7_fia_issuers.columns.lei", {
            ns: "tables",
            defaultValue: "LEI",
          })}
          control={form.control}
          multiFieldOptions={multiFieldOptions}
        />
        <InputField
          name="identifiant_fiscal_du_sous_jacent"
          label={i18n.t(
            "a7_fia_issuers.columns.identifiant_fiscal_du_sous_jacent",
            {
              ns: "tables",
              defaultValue: "Tax identifier",
            },
          )}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-2">
        <InputField
          name="societe_mere_id"
          label={i18n.t("a7_fia_issuers.columns.societe_mere_name", {
            ns: "tables",
            defaultValue: "Parent company",
          })}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
    </div>
  ),
};
